import React, { useState } from "react";
import Layout from "../PageLayout/LoginLayout";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom"; // import useNavigate too
import { registerUser } from "../services/auth.service";

export default function RegisterDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location?.state?.email || ""; // get email from router state

  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleRegister = async (e) => {
    if (e && typeof e.preventDefault === "function") e.preventDefault();
    setError("");
    try {
      setSubmitting(true);
      const fullName = [name, surname].filter(Boolean).join(" ").trim();
      let verificationToken = "";
      try {
        verificationToken = localStorage.getItem("verificationToken") || "";
      } catch (_) {}
      const payload = { email, name: fullName, password, verificationToken };
      await registerUser(payload);
      navigate("/login");
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || "Registration failed";
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout>
      <h2 className="text-xl font-semibold text-gray-800 mb-1">
        Specify account details
      </h2>
      <p className="text-gray-500 text-sm mb-6">
        You must fill out the information below to complete your membership.
      </p>

      <form onSubmit={handleRegister}>
        {/* Email */}
        <label className="block text-sm text-gray-600 mb-1">E-Mail address</label>
        <input
          type="email"
          value={email}
          readOnly
          className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-400 mb-4"
        />

        {/* Name & Surname */}
        <div className="flex gap-4 mb-4">
          <div className="flex-1">
            <label className="block text-sm text-gray-600 mb-1">Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-400"
            />
          </div>
          <div className="flex-1">
            <label className="block text-sm text-gray-600 mb-1">Surname</label>
            <input
              type="text"
              value={surname}
              onChange={(e) => setSurname(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-400"
            />
          </div>
        </div>

        {/* Password */}
        <div className="mb-4">
          <label className="block text-sm text-gray-600 mb-1">Password</label>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 pr-10 text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-400"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute inset-y-0 right-3 flex items-center text-gray-500"
            >
              {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
            </button>
          </div>
          <p className="text-xs text-gray-500 mt-1">
            Your password must be at least 8 characters long and contain at least one letter, number or special character.
          </p>
        </div>

        {/* Checkbox */}
        <label className="flex items-start text-sm text-gray-600 mb-6">
          <input type="checkbox" className="mt-1 mr-2" defaultChecked />
          <span>
            Sumptus tubineus caput vero clivis communis voluptate textilis
            deprecator cervus. Iste adficito cupedia sollers.
          </span>
        </label>

        {/* Submit */}
        <button
          type="submit"
          disabled={submitting}
          className="w-full bg-[#18192B] text-white py-2 rounded-lg hover:bg-[#10111A] transition disabled:opacity-60"
        >
          {submitting ? "Submitting..." : "Register"}
        </button>
      </form>
      {error && <div className="mt-2 text-sm text-red-600">{error}</div>}
    </Layout>
  );
}
